import { Button, Modal, Stack, Typography, Fade, Box, IconButton } from "@mui/material";
import PropTypes from "prop-types";
import CloseIcon from "@mui/icons-material/Close";

const ConfirmDialog = ({ open, handleClose, handleConfirm, title, description, confirmText, cancelText }) => {
    return (
        <Modal
            open={open}
            onClose={handleClose}
            closeAfterTransition
            aria-labelledby="confirm-modal-title"
            aria-describedby="confirm-modal-description"
        >
            <Fade in={open}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: { xs: "90%", sm: 400 },
                        backgroundColor: "background.paper",
                        boxShadow: 24,
                        borderRadius: 2,
                        p: 3,
                        outline: "none",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                        <Typography id="confirm-modal-title" variant="h6" component="h2" fontWeight="bold">
                            {title}
                        </Typography>
                        <IconButton aria-label="close" onClick={handleClose} size="small">
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>
                    
                    <Typography id="confirm-modal-description" sx={{ mb: 3 }} color="text.secondary">
                        {description}
                    </Typography>
                    
                    <Stack direction="row" spacing={2} justifyContent="flex-end">
                        <Button 
                            variant="outlined"
                            onClick={handleClose}
                            sx={{ minWidth: 100 }}
                        >
                            {cancelText}
                        </Button>
                        <Button 
                            variant="contained" 
                            color="primary" 
                            onClick={handleConfirm}
                            sx={{ 
                                minWidth: 100,
                                boxShadow: 2,
                                '&:hover': { boxShadow: 4 }
                            }}
                        >
                            {confirmText}
                        </Button>
                    </Stack>
                </Box>
            </Fade>
        </Modal>
    );
};

ConfirmDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleConfirm: PropTypes.func.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    confirmText: PropTypes.string.isRequired,
    cancelText: PropTypes.string.isRequired,
};

export default ConfirmDialog;